import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { set_width } from "./redux/actions/LayoutAction";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import CreateStorePage from "./pages/createStorepage/CreateStorePage";
import LoginPage from "./pages/loginpage/LoginPage";
import NewLoginPage from "./pages/login/NewLogin";
import RegisterPage from "./pages/register/Register";
import VerifyEmail from "./pages/verify-email/VerifyEmail";
import PageContainer from "./pages/vendor/PageContainer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EmptyPage from "./pages/emptyPage/EmptyPage";
import { Redirect } from "react-router-dom";
import axios from "axios";
import { set_redirect_home } from "./redux/actions/NotFoundAction";
import NotFound from "./components/NotFound/NotFound";
import CenteredSpinner from "./components/spinner/CenteredSpinner";
import $ from "jquery";
import SetPassword from "./pages/set-password/SetPassword";
import ResetPassword from "./pages/reset-password/ResetPassword";
require("dotenv").config();

function App(props) {
  const [redirect, setRedirect] = useState();

  axios.interceptors.response.use(
    (res) => {
      if (res.status === 404) {
        props?.set_redirect_home(true);
      }
      return res;
    },
    (err) => {
      if (parseInt(err?.response?.status) === 404) {
        props?.set_redirect_home(true);
      }
      return Promise.reject(err);
    },
  );

  function getScreenWidth(width) {
    if (width >= 1440) {
      return "xxxl";
    } else if (width >= 1200) {
      return "xxl";
    } else if (width >= 1024) {
      return "xl";
    } else if (width >= 992) {
      return "lg";
    } else if (width >= 768) {
      return "md";
    } else {
      return "sm";
    }
  }
  window.addEventListener("resize", () => {
    props?.set_width(getScreenWidth(window.innerWidth));
  });

  useEffect(() => {
    props.set_width(getScreenWidth(window.innerWidth));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    props.load
      ? $("body").css("overflow-x", "hidden")
      : $("body").css("overflow-x", "auto");
    // eslint-disable-next-line
  }, [props.load]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (window.location.href?.startsWith("https://vendor.alisuq.com")) {
      console.log("redirecting to vendor.alisouq.com");
      setRedirect(true);
      window.location.href = window.location.href?.replace(
        "https://vendor.alisuq.com",
        "https://vendor.alisouq.com",
      );
    }
  }, []);

  return (
    <>
      {redirect ? (
        <></>
      ) : (
        <Router>
          <Switch>
            <React.Fragment>
              {/* <Route exact path="/" component={LoginPage} /> */}
              <Route exact path="/" component={NewLoginPage} />
              <Route exact path="/register" component={RegisterPage} />
              <Route exact path="/verify-email" component={VerifyEmail} />
              <Route exact path="/set-password" component={SetPassword} />
              <Route exact path="/reset-password" component={ResetPassword} />
              <Route exact path="/message" component={EmptyPage} />
              <Route path="/create-store" component={CreateStorePage} />
              <Route path="/vendor" component={PageContainer} />
              <Route exact path="/not-found" component={NotFound} />
            </React.Fragment>
          </Switch>
          <ToastContainer
            position="bottom-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            draggable
            pauseOnHover
          />
          {props.redirect && <Redirect to="/not-found" />}
        </Router>
      )}
      {props.load && <CenteredSpinner />}
    </>
  );
}

const mapStateToProps = (state) => {
  return { redirect: state.notFound.redirect, load: state.layout.isLoading };
};

const mapDispatchToProps = {
  set_redirect_home,
  set_width,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
